// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/rag.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { RAG, RAGClass, RAGCollection } from "../v1/rag_pb.js";
import { file_agentplatform_v1_rag } from "../v1/rag_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/rag.proto.
 */
export const file_agentplatform_httpv2_rag: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v1_rag, file_buf_validate_validate, file_google_api_annotations, file_google_protobuf_struct]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGClassesResponse
 */
export type ListRAGClassesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListRAGClassesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListRAGClassesData data = 4;
   */
  data?: ListRAGClassesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGClassesResponse.
 * Use `create(ListRAGClassesResponseSchema)` to create a new message.
 */
export const ListRAGClassesResponseSchema: GenMessage<ListRAGClassesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 0);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGClassesData
 */
export type ListRAGClassesData = Message<"infinigence.infini.agentplatform.httpv2.ListRAGClassesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.RAGClass items = 1;
   */
  items: RAGClass[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGClassesData.
 * Use `create(ListRAGClassesDataSchema)` to create a new message.
 */
export const ListRAGClassesDataSchema: GenMessage<ListRAGClassesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateRAGClassRequest
 */
export type CreateRAGClassRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateRAGClassRequest"> & {
  /**
   * RAG 服务类定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"rag_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAGClass rag_class = 1 [json_name = "rag_class"];
   */
  ragClass?: RAGClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateRAGClassRequest.
 * Use `create(CreateRAGClassRequestSchema)` to create a new message.
 */
export const CreateRAGClassRequestSchema: GenMessage<CreateRAGClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateRAGClassResponse
 */
export type CreateRAGClassResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateRAGClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAGClass data = 4;
   */
  data?: RAGClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateRAGClassResponse.
 * Use `create(CreateRAGClassResponseSchema)` to create a new message.
 */
export const CreateRAGClassResponseSchema: GenMessage<CreateRAGClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGClassRequest
 */
export type GetRAGClassRequest = Message<"infinigence.infini.agentplatform.httpv2.GetRAGClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGClassRequest.
 * Use `create(GetRAGClassRequestSchema)` to create a new message.
 */
export const GetRAGClassRequestSchema: GenMessage<GetRAGClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGClassResponse
 */
export type GetRAGClassResponse = Message<"infinigence.infini.agentplatform.httpv2.GetRAGClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAGClass data = 4;
   */
  data?: RAGClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGClassResponse.
 * Use `create(GetRAGClassResponseSchema)` to create a new message.
 */
export const GetRAGClassResponseSchema: GenMessage<GetRAGClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateRAGClassRequest
 */
export type UpdateRAGClassRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateRAGClassRequest"> & {
  /**
   * 待更新 RAG 服务类 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * RAG 服务类定义（id / 归属由服务端回填）
   * @gotags: json:"rag_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAGClass rag_class = 2 [json_name = "rag_class"];
   */
  ragClass?: RAGClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateRAGClassRequest.
 * Use `create(UpdateRAGClassRequestSchema)` to create a new message.
 */
export const UpdateRAGClassRequestSchema: GenMessage<UpdateRAGClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateRAGClassResponse
 */
export type UpdateRAGClassResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateRAGClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAGClass data = 4;
   */
  data?: RAGClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateRAGClassResponse.
 * Use `create(UpdateRAGClassResponseSchema)` to create a new message.
 */
export const UpdateRAGClassResponseSchema: GenMessage<UpdateRAGClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGClassRequest
 */
export type DeleteRAGClassRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGClassRequest.
 * Use `create(DeleteRAGClassRequestSchema)` to create a new message.
 */
export const DeleteRAGClassRequestSchema: GenMessage<DeleteRAGClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 8);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGClassResponse
 */
export type DeleteRAGClassResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGClassResponse.
 * Use `create(DeleteRAGClassResponseSchema)` to create a new message.
 */
export const DeleteRAGClassResponseSchema: GenMessage<DeleteRAGClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGsResponse
 */
export type ListRAGsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListRAGsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListRAGsData data = 4;
   */
  data?: ListRAGsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGsResponse.
 * Use `create(ListRAGsResponseSchema)` to create a new message.
 */
export const ListRAGsResponseSchema: GenMessage<ListRAGsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 10);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGsData
 */
export type ListRAGsData = Message<"infinigence.infini.agentplatform.httpv2.ListRAGsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.RAG items = 1;
   */
  items: RAG[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGsData.
 * Use `create(ListRAGsDataSchema)` to create a new message.
 */
export const ListRAGsDataSchema: GenMessage<ListRAGsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateRAGRequest
 */
export type CreateRAGRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateRAGRequest"> & {
  /**
   * RAG 实例定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"rag"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAG rag = 1;
   */
  rag?: RAG | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateRAGRequest.
 * Use `create(CreateRAGRequestSchema)` to create a new message.
 */
export const CreateRAGRequestSchema: GenMessage<CreateRAGRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateRAGResponse
 */
export type CreateRAGResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateRAGResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAG data = 4;
   */
  data?: RAG | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateRAGResponse.
 * Use `create(CreateRAGResponseSchema)` to create a new message.
 */
export const CreateRAGResponseSchema: GenMessage<CreateRAGResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGRequest
 */
export type GetRAGRequest = Message<"infinigence.infini.agentplatform.httpv2.GetRAGRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGRequest.
 * Use `create(GetRAGRequestSchema)` to create a new message.
 */
export const GetRAGRequestSchema: GenMessage<GetRAGRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGResponse
 */
export type GetRAGResponse = Message<"infinigence.infini.agentplatform.httpv2.GetRAGResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAG data = 4;
   */
  data?: RAG | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGResponse.
 * Use `create(GetRAGResponseSchema)` to create a new message.
 */
export const GetRAGResponseSchema: GenMessage<GetRAGResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateRAGRequest
 */
export type UpdateRAGRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateRAGRequest"> & {
  /**
   * 待更新 RAG 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * RAG 实例定义（id / 归属由服务端回填）
   * @gotags: json:"rag"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAG rag = 2;
   */
  rag?: RAG | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateRAGRequest.
 * Use `create(UpdateRAGRequestSchema)` to create a new message.
 */
export const UpdateRAGRequestSchema: GenMessage<UpdateRAGRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateRAGResponse
 */
export type UpdateRAGResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateRAGResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAG data = 4;
   */
  data?: RAG | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateRAGResponse.
 * Use `create(UpdateRAGResponseSchema)` to create a new message.
 */
export const UpdateRAGResponseSchema: GenMessage<UpdateRAGResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGRequest
 */
export type DeleteRAGRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGRequest.
 * Use `create(DeleteRAGRequestSchema)` to create a new message.
 */
export const DeleteRAGRequestSchema: GenMessage<DeleteRAGRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 18);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGResponse
 */
export type DeleteRAGResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGResponse.
 * Use `create(DeleteRAGResponseSchema)` to create a new message.
 */
export const DeleteRAGResponseSchema: GenMessage<DeleteRAGResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 19);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGCollectionsResponse
 */
export type ListRAGCollectionsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListRAGCollectionsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListRAGCollectionsData data = 4;
   */
  data?: ListRAGCollectionsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGCollectionsResponse.
 * Use `create(ListRAGCollectionsResponseSchema)` to create a new message.
 */
export const ListRAGCollectionsResponseSchema: GenMessage<ListRAGCollectionsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 20);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGCollectionsData
 */
export type ListRAGCollectionsData = Message<"infinigence.infini.agentplatform.httpv2.ListRAGCollectionsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.RAGCollection items = 1;
   */
  items: RAGCollection[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGCollectionsData.
 * Use `create(ListRAGCollectionsDataSchema)` to create a new message.
 */
export const ListRAGCollectionsDataSchema: GenMessage<ListRAGCollectionsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 21);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateRAGCollectionRequest
 */
export type CreateRAGCollectionRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateRAGCollectionRequest"> & {
  /**
   * 知识库展示名（必填）
   * @gotags: json:"collection_display_name"
   *
   * @generated from field: string collection_display_name = 1 [json_name = "collection_display_name"];
   */
  collectionDisplayName: string;

  /**
   * 描述（可选）
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * 向量维度（可选，>0 生效）
   * @gotags: json:"vector_size,omitempty"
   *
   * @generated from field: int32 vector_size = 3 [json_name = "vector_size"];
   */
  vectorSize: number;

  /**
   * 分块重叠（可选，>=0 生效）
   * @gotags: json:"chunk_overlap,omitempty"
   *
   * @generated from field: int32 chunk_overlap = 4 [json_name = "chunk_overlap"];
   */
  chunkOverlap: number;

  /**
   * 距离度量（可选，如 Cosine / Dot / Euclid）
   * @gotags: json:"distance,omitempty"
   *
   * @generated from field: string distance = 5;
   */
  distance: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateRAGCollectionRequest.
 * Use `create(CreateRAGCollectionRequestSchema)` to create a new message.
 */
export const CreateRAGCollectionRequestSchema: GenMessage<CreateRAGCollectionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 22);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateRAGCollectionResponse
 */
export type CreateRAGCollectionResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateRAGCollectionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAGCollection data = 4;
   */
  data?: RAGCollection | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateRAGCollectionResponse.
 * Use `create(CreateRAGCollectionResponseSchema)` to create a new message.
 */
export const CreateRAGCollectionResponseSchema: GenMessage<CreateRAGCollectionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 23);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGCollectionRequest
 */
export type DeleteRAGCollectionRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGCollectionRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGCollectionRequest.
 * Use `create(DeleteRAGCollectionRequestSchema)` to create a new message.
 */
export const DeleteRAGCollectionRequestSchema: GenMessage<DeleteRAGCollectionRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 24);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGCollectionResponse
 */
export type DeleteRAGCollectionResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGCollectionResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 透传 v1 的 {deleted, collection_name, qdrant_deleted}
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGCollectionResponse.
 * Use `create(DeleteRAGCollectionResponseSchema)` to create a new message.
 */
export const DeleteRAGCollectionResponseSchema: GenMessage<DeleteRAGCollectionResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 25);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGIngestJobsResponse
 */
export type ListRAGIngestJobsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListRAGIngestJobsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 透传 v1 的 {total, jobs:[...]}
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGIngestJobsResponse.
 * Use `create(ListRAGIngestJobsResponseSchema)` to create a new message.
 */
export const ListRAGIngestJobsResponseSchema: GenMessage<ListRAGIngestJobsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 26);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGIngestJobRequest
 */
export type DeleteRAGIngestJobRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGIngestJobRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGIngestJobRequest.
 * Use `create(DeleteRAGIngestJobRequestSchema)` to create a new message.
 */
export const DeleteRAGIngestJobRequestSchema: GenMessage<DeleteRAGIngestJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 27);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGIngestJobResponse
 */
export type DeleteRAGIngestJobResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGIngestJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGIngestJobResponse.
 * Use `create(DeleteRAGIngestJobResponseSchema)` to create a new message.
 */
export const DeleteRAGIngestJobResponseSchema: GenMessage<DeleteRAGIngestJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 28);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.BatchDeleteRAGIngestJobsRequest
 */
export type BatchDeleteRAGIngestJobsRequest = Message<"infinigence.infini.agentplatform.httpv2.BatchDeleteRAGIngestJobsRequest"> & {
  /**
   * 待删除的摄取任务 ID 列表（至少 1 个）
   * @gotags: json:"ids"
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.BatchDeleteRAGIngestJobsRequest.
 * Use `create(BatchDeleteRAGIngestJobsRequestSchema)` to create a new message.
 */
export const BatchDeleteRAGIngestJobsRequestSchema: GenMessage<BatchDeleteRAGIngestJobsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 29);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.BatchDeleteRAGIngestJobsResponse
 */
export type BatchDeleteRAGIngestJobsResponse = Message<"infinigence.infini.agentplatform.httpv2.BatchDeleteRAGIngestJobsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.BatchDeleteRAGIngestJobsResponse.
 * Use `create(BatchDeleteRAGIngestJobsResponseSchema)` to create a new message.
 */
export const BatchDeleteRAGIngestJobsResponseSchema: GenMessage<BatchDeleteRAGIngestJobsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 30);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RerunRAGIngestJobRequest
 */
export type RerunRAGIngestJobRequest = Message<"infinigence.infini.agentplatform.httpv2.RerunRAGIngestJobRequest"> & {
  /**
   * 待重跑的摄取任务 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 飞书用户 token（仅 feishu 重跑需要）
   * @gotags: json:"feishu_user_token,omitempty"
   *
   * @generated from field: string feishu_user_token = 2 [json_name = "feishu_user_token"];
   */
  feishuUserToken: string;

  /**
   * 飞书 App ID（仅 feishu 重跑需要）
   * @gotags: json:"feishu_app_id,omitempty"
   *
   * @generated from field: string feishu_app_id = 3 [json_name = "feishu_app_id"];
   */
  feishuAppId: string;

  /**
   * 飞书 App Secret（仅 feishu 重跑需要）
   * @gotags: json:"feishu_app_secret,omitempty"
   *
   * @generated from field: string feishu_app_secret = 4 [json_name = "feishu_app_secret"];
   */
  feishuAppSecret: string;

  /**
   * 飞书 dev space（仅 feishu 重跑需要）
   * @gotags: json:"feishu_dev_space,omitempty"
   *
   * @generated from field: string feishu_dev_space = 5 [json_name = "feishu_dev_space"];
   */
  feishuDevSpace: string;

  /**
   * 是否递归（feishu 目录 / web sitemap）
   * @gotags: json:"recursive,omitempty"
   *
   * @generated from field: bool recursive = 6;
   */
  recursive: boolean;

  /**
   * 名称（rows 缺失时用于按名回退定位）
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 7;
   */
  name: string;

  /**
   * Qdrant collection 名（rows 缺失时用于按名回退定位）
   * @gotags: json:"qdrant_collection_name,omitempty"
   *
   * @generated from field: string qdrant_collection_name = 8 [json_name = "qdrant_collection_name"];
   */
  qdrantCollectionName: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RerunRAGIngestJobRequest.
 * Use `create(RerunRAGIngestJobRequestSchema)` to create a new message.
 */
export const RerunRAGIngestJobRequestSchema: GenMessage<RerunRAGIngestJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 31);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RerunRAGIngestJobResponse
 */
export type RerunRAGIngestJobResponse = Message<"infinigence.infini.agentplatform.httpv2.RerunRAGIngestJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RerunRAGIngestJobResponse.
 * Use `create(RerunRAGIngestJobResponseSchema)` to create a new message.
 */
export const RerunRAGIngestJobResponseSchema: GenMessage<RerunRAGIngestJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 32);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UploadRAGPDFsRequest
 */
export type UploadRAGPDFsRequest = Message<"infinigence.infini.agentplatform.httpv2.UploadRAGPDFsRequest"> & {
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UploadRAGPDFsRequest.
 * Use `create(UploadRAGPDFsRequestSchema)` to create a new message.
 */
export const UploadRAGPDFsRequestSchema: GenMessage<UploadRAGPDFsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 33);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UploadRAGPDFsResponse
 */
export type UploadRAGPDFsResponse = Message<"infinigence.infini.agentplatform.httpv2.UploadRAGPDFsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 透传 v1 的 {results:[...]}
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UploadRAGPDFsResponse.
 * Use `create(UploadRAGPDFsResponseSchema)` to create a new message.
 */
export const UploadRAGPDFsResponseSchema: GenMessage<UploadRAGPDFsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 34);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UploadRAGFeishuRequest
 */
export type UploadRAGFeishuRequest = Message<"infinigence.infini.agentplatform.httpv2.UploadRAGFeishuRequest"> & {
  /**
   * 飞书文档 ID（必填）
   * @gotags: json:"feishu_document_id"
   *
   * @generated from field: string feishu_document_id = 1 [json_name = "feishu_document_id"];
   */
  feishuDocumentId: string;

  /**
   * 是否递归摄取子文档
   * @gotags: json:"recursive,omitempty"
   *
   * @generated from field: bool recursive = 2;
   */
  recursive: boolean;

  /**
   * 目标 Qdrant collection 名（必填）
   * @gotags: json:"qdrant_collection_name"
   *
   * @generated from field: string qdrant_collection_name = 3 [json_name = "qdrant_collection_name"];
   */
  qdrantCollectionName: string;

  /**
   * 名称（可选）
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * 超时秒数（可选，>=0）
   * @gotags: json:"timeout_seconds,omitempty"
   *
   * @generated from field: int32 timeout_seconds = 5 [json_name = "timeout_seconds"];
   */
  timeoutSeconds: number;

  /**
   * 飞书用户 token（必填）
   * @gotags: json:"feishu_user_token"
   *
   * @generated from field: string feishu_user_token = 6 [json_name = "feishu_user_token"];
   */
  feishuUserToken: string;

  /**
   * 飞书 App ID（可选）
   * @gotags: json:"feishu_app_id,omitempty"
   *
   * @generated from field: string feishu_app_id = 7 [json_name = "feishu_app_id"];
   */
  feishuAppId: string;

  /**
   * 飞书 App Secret（可选）
   * @gotags: json:"feishu_app_secret,omitempty"
   *
   * @generated from field: string feishu_app_secret = 8 [json_name = "feishu_app_secret"];
   */
  feishuAppSecret: string;

  /**
   * 飞书 dev space（可选）
   * @gotags: json:"feishu_dev_space,omitempty"
   *
   * @generated from field: string feishu_dev_space = 9 [json_name = "feishu_dev_space"];
   */
  feishuDevSpace: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UploadRAGFeishuRequest.
 * Use `create(UploadRAGFeishuRequestSchema)` to create a new message.
 */
export const UploadRAGFeishuRequestSchema: GenMessage<UploadRAGFeishuRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 35);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UploadRAGFeishuResponse
 */
export type UploadRAGFeishuResponse = Message<"infinigence.infini.agentplatform.httpv2.UploadRAGFeishuResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UploadRAGFeishuResponse.
 * Use `create(UploadRAGFeishuResponseSchema)` to create a new message.
 */
export const UploadRAGFeishuResponseSchema: GenMessage<UploadRAGFeishuResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 36);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UploadRAGWebRequest
 */
export type UploadRAGWebRequest = Message<"infinigence.infini.agentplatform.httpv2.UploadRAGWebRequest"> & {
  /**
   * 待摄取的 URL 列表（与 sitemap_url 二选一）
   * @gotags: json:"urls,omitempty"
   *
   * @generated from field: repeated string urls = 1;
   */
  urls: string[];

  /**
   * 目标 Qdrant collection 名（必填）
   * @gotags: json:"qdrant_collection_name"
   *
   * @generated from field: string qdrant_collection_name = 2 [json_name = "qdrant_collection_name"];
   */
  qdrantCollectionName: string;

  /**
   * sitemap URL（与 urls 二选一）
   * @gotags: json:"sitemap_url,omitempty"
   *
   * @generated from field: string sitemap_url = 3 [json_name = "sitemap_url"];
   */
  sitemapUrl: string;

  /**
   * 超时秒数（可选，>=0）
   * @gotags: json:"timeout_seconds,omitempty"
   *
   * @generated from field: int32 timeout_seconds = 4 [json_name = "timeout_seconds"];
   */
  timeoutSeconds: number;

  /**
   * 自动重跑间隔小时数（0 = 不自动重跑）
   * @gotags: json:"auto_rerun_interval_hours,omitempty"
   *
   * @generated from field: int32 auto_rerun_interval_hours = 5 [json_name = "auto_rerun_interval_hours"];
   */
  autoRerunIntervalHours: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UploadRAGWebRequest.
 * Use `create(UploadRAGWebRequestSchema)` to create a new message.
 */
export const UploadRAGWebRequestSchema: GenMessage<UploadRAGWebRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 37);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UploadRAGWebResponse
 */
export type UploadRAGWebResponse = Message<"infinigence.infini.agentplatform.httpv2.UploadRAGWebResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UploadRAGWebResponse.
 * Use `create(UploadRAGWebResponseSchema)` to create a new message.
 */
export const UploadRAGWebResponseSchema: GenMessage<UploadRAGWebResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 38);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ParseRAGSitemapRequest
 */
export type ParseRAGSitemapRequest = Message<"infinigence.infini.agentplatform.httpv2.ParseRAGSitemapRequest"> & {
  /**
   * sitemap URL（必填）
   * @gotags: json:"url"
   *
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ParseRAGSitemapRequest.
 * Use `create(ParseRAGSitemapRequestSchema)` to create a new message.
 */
export const ParseRAGSitemapRequestSchema: GenMessage<ParseRAGSitemapRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 39);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ParseRAGSitemapResponse
 */
export type ParseRAGSitemapResponse = Message<"infinigence.infini.agentplatform.httpv2.ParseRAGSitemapResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 透传 v1 的 {urls, total, unreachable, original_total}
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ParseRAGSitemapResponse.
 * Use `create(ParseRAGSitemapResponseSchema)` to create a new message.
 */
export const ParseRAGSitemapResponseSchema: GenMessage<ParseRAGSitemapResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 40);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobRequest
 */
export type GetRAGIngestJobRequest = Message<"infinigence.infini.agentplatform.httpv2.GetRAGIngestJobRequest"> & {
  /**
   * 摄取任务 ID
   * @gotags: json:"job_id"
   *
   * @generated from field: string job_id = 1 [json_name = "job_id"];
   */
  jobId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobRequest.
 * Use `create(GetRAGIngestJobRequestSchema)` to create a new message.
 */
export const GetRAGIngestJobRequestSchema: GenMessage<GetRAGIngestJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 41);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobResponse
 */
export type GetRAGIngestJobResponse = Message<"infinigence.infini.agentplatform.httpv2.GetRAGIngestJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 上游任务状态原始 JSON 透传
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobResponse.
 * Use `create(GetRAGIngestJobResponseSchema)` to create a new message.
 */
export const GetRAGIngestJobResponseSchema: GenMessage<GetRAGIngestJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 42);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobLogsRequest
 */
export type GetRAGIngestJobLogsRequest = Message<"infinigence.infini.agentplatform.httpv2.GetRAGIngestJobLogsRequest"> & {
  /**
   * 摄取任务 ID
   * @gotags: json:"job_id"
   *
   * @generated from field: string job_id = 1 [json_name = "job_id"];
   */
  jobId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobLogsRequest.
 * Use `create(GetRAGIngestJobLogsRequestSchema)` to create a new message.
 */
export const GetRAGIngestJobLogsRequestSchema: GenMessage<GetRAGIngestJobLogsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 43);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobLogsResponse
 */
export type GetRAGIngestJobLogsResponse = Message<"infinigence.infini.agentplatform.httpv2.GetRAGIngestJobLogsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 上游任务日志原始 JSON / 文本透传
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetRAGIngestJobLogsResponse.
 * Use `create(GetRAGIngestJobLogsResponseSchema)` to create a new message.
 */
export const GetRAGIngestJobLogsResponseSchema: GenMessage<GetRAGIngestJobLogsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 44);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.SearchRAGVectorRequest
 */
export type SearchRAGVectorRequest = Message<"infinigence.infini.agentplatform.httpv2.SearchRAGVectorRequest"> & {
  /**
   * 目标 collection 名（必填）
   * @gotags: json:"collection_name"
   *
   * @generated from field: string collection_name = 1 [json_name = "collection_name"];
   */
  collectionName: string;

  /**
   * 检索 query（必填）
   * @gotags: json:"query"
   *
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * top_k（可选，>=0）
   * @gotags: json:"top_k,omitempty"
   *
   * @generated from field: int32 top_k = 3 [json_name = "top_k"];
   */
  topK: number;

  /**
   * 向量维度（可选，>=0）
   * @gotags: json:"vector_size,omitempty"
   *
   * @generated from field: int32 vector_size = 4 [json_name = "vector_size"];
   */
  vectorSize: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.SearchRAGVectorRequest.
 * Use `create(SearchRAGVectorRequestSchema)` to create a new message.
 */
export const SearchRAGVectorRequestSchema: GenMessage<SearchRAGVectorRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 45);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.SearchRAGVectorResponse
 */
export type SearchRAGVectorResponse = Message<"infinigence.infini.agentplatform.httpv2.SearchRAGVectorResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 上游检索结果原始 JSON 透传
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.SearchRAGVectorResponse.
 * Use `create(SearchRAGVectorResponseSchema)` to create a new message.
 */
export const SearchRAGVectorResponseSchema: GenMessage<SearchRAGVectorResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 46);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListRAGRerunJobsResponse
 */
export type ListRAGRerunJobsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListRAGRerunJobsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 透传 v1 的 {total, jobs:[...]}
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListRAGRerunJobsResponse.
 * Use `create(ListRAGRerunJobsResponseSchema)` to create a new message.
 */
export const ListRAGRerunJobsResponseSchema: GenMessage<ListRAGRerunJobsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 47);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGRerunJobRequest
 */
export type DeleteRAGRerunJobRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGRerunJobRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGRerunJobRequest.
 * Use `create(DeleteRAGRerunJobRequestSchema)` to create a new message.
 */
export const DeleteRAGRerunJobRequestSchema: GenMessage<DeleteRAGRerunJobRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 48);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteRAGRerunJobResponse
 */
export type DeleteRAGRerunJobResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteRAGRerunJobResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteRAGRerunJobResponse.
 * Use `create(DeleteRAGRerunJobResponseSchema)` to create a new message.
 */
export const DeleteRAGRerunJobResponseSchema: GenMessage<DeleteRAGRerunJobResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 49);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RAGHealthRequest
 */
export type RAGHealthRequest = Message<"infinigence.infini.agentplatform.httpv2.RAGHealthRequest"> & {
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RAGHealthRequest.
 * Use `create(RAGHealthRequestSchema)` to create a new message.
 */
export const RAGHealthRequestSchema: GenMessage<RAGHealthRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 50);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RAGHealthResponse
 */
export type RAGHealthResponse = Message<"infinigence.infini.agentplatform.httpv2.RAGHealthResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 上游健康状态原始 JSON 透传
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Value data = 4;
   */
  data?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RAGHealthResponse.
 * Use `create(RAGHealthResponseSchema)` to create a new message.
 */
export const RAGHealthResponseSchema: GenMessage<RAGHealthResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_rag, 51);

/**
 * RAGHTTPV2Service
 * RAG 实例 / RAG 服务类 的 CRUD。
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service
 */
export const RAGHTTPV2Service: GenService<{
  /**
   * ---- RAG Class ----
   * 列出 RAG 服务类（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.ListRAGClasses
   */
  listRAGClasses: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListRAGClassesResponseSchema;
  },
  /**
   * 创建 RAG 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.CreateRAGClass
   */
  createRAGClass: {
    methodKind: "unary";
    input: typeof CreateRAGClassRequestSchema;
    output: typeof CreateRAGClassResponseSchema;
  },
  /**
   * 获取单个 RAG 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.GetRAGClass
   */
  getRAGClass: {
    methodKind: "unary";
    input: typeof GetRAGClassRequestSchema;
    output: typeof GetRAGClassResponseSchema;
  },
  /**
   * 更新 RAG 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.UpdateRAGClass
   */
  updateRAGClass: {
    methodKind: "unary";
    input: typeof UpdateRAGClassRequestSchema;
    output: typeof UpdateRAGClassResponseSchema;
  },
  /**
   * 删除 RAG 服务类（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.DeleteRAGClass
   */
  deleteRAGClass: {
    methodKind: "unary";
    input: typeof DeleteRAGClassRequestSchema;
    output: typeof DeleteRAGClassResponseSchema;
  },
  /**
   * ---- RAG Instance ----
   * 列出 RAG 实例（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.ListRAGs
   */
  listRAGs: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListRAGsResponseSchema;
  },
  /**
   * 创建 RAG 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.CreateRAG
   */
  createRAG: {
    methodKind: "unary";
    input: typeof CreateRAGRequestSchema;
    output: typeof CreateRAGResponseSchema;
  },
  /**
   * 获取单个 RAG 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.GetRAG
   */
  getRAG: {
    methodKind: "unary";
    input: typeof GetRAGRequestSchema;
    output: typeof GetRAGResponseSchema;
  },
  /**
   * 更新 RAG 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.UpdateRAG
   */
  updateRAG: {
    methodKind: "unary";
    input: typeof UpdateRAGRequestSchema;
    output: typeof UpdateRAGResponseSchema;
  },
  /**
   * 删除 RAG 实例（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.DeleteRAG
   */
  deleteRAG: {
    methodKind: "unary";
    input: typeof DeleteRAGRequestSchema;
    output: typeof DeleteRAGResponseSchema;
  },
  /**
   * ---- RAG Collections（知识库 collection 登记）----
   * 列出当前用户名下的 RAG collection（分页 / 名称模糊）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.ListRAGCollections
   */
  listRAGCollections: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListRAGCollectionsResponseSchema;
  },
  /**
   * 创建 / 复用一个 RAG collection（同名归属幂等复用）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.CreateRAGCollection
   */
  createRAGCollection: {
    methodKind: "unary";
    input: typeof CreateRAGCollectionRequestSchema;
    output: typeof CreateRAGCollectionResponseSchema;
  },
  /**
   * 删除一个 RAG collection（同时删除 Qdrant collection）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.DeleteRAGCollection
   */
  deleteRAGCollection: {
    methodKind: "unary";
    input: typeof DeleteRAGCollectionRequestSchema;
    output: typeof DeleteRAGCollectionResponseSchema;
  },
  /**
   * ---- RAG 摄取任务（ingest jobs）----
   * 列出摄取任务（分页）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.ListRAGIngestJobs
   */
  listRAGIngestJobs: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListRAGIngestJobsResponseSchema;
  },
  /**
   * 删除单个摄取任务（清理 Qdrant 向量 + 软删上游记录）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.DeleteRAGIngestJob
   */
  deleteRAGIngestJob: {
    methodKind: "unary";
    input: typeof DeleteRAGIngestJobRequestSchema;
    output: typeof DeleteRAGIngestJobResponseSchema;
  },
  /**
   * 批量删除摄取任务
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.BatchDeleteRAGIngestJobs
   */
  batchDeleteRAGIngestJobs: {
    methodKind: "unary";
    input: typeof BatchDeleteRAGIngestJobsRequestSchema;
    output: typeof BatchDeleteRAGIngestJobsResponseSchema;
  },
  /**
   * 重跑一个摄取任务（web / sitemap / feishu，蓝绿增量）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.RerunRAGIngestJob
   */
  rerunRAGIngestJob: {
    methodKind: "unary";
    input: typeof RerunRAGIngestJobRequestSchema;
    output: typeof RerunRAGIngestJobResponseSchema;
  },
  /**
   * ---- RAG 摄取入口（ingestion）----
   * 上传 PDF / DOCX / Markdown（multipart/form-data，handler 直接读取表单）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.UploadRAGPDFs
   */
  uploadRAGPDFs: {
    methodKind: "unary";
    input: typeof UploadRAGPDFsRequestSchema;
    output: typeof UploadRAGPDFsResponseSchema;
  },
  /**
   * 从飞书文档摄取
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.UploadRAGFeishu
   */
  uploadRAGFeishu: {
    methodKind: "unary";
    input: typeof UploadRAGFeishuRequestSchema;
    output: typeof UploadRAGFeishuResponseSchema;
  },
  /**
   * 从网页 / sitemap URL 摄取（可配置自动重跑）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.UploadRAGWeb
   */
  uploadRAGWeb: {
    methodKind: "unary";
    input: typeof UploadRAGWebRequestSchema;
    output: typeof UploadRAGWebResponseSchema;
  },
  /**
   * 解析 sitemap XML，返回可达 URL 列表
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.ParseRAGSitemap
   */
  parseRAGSitemap: {
    methodKind: "unary";
    input: typeof ParseRAGSitemapRequestSchema;
    output: typeof ParseRAGSitemapResponseSchema;
  },
  /**
   * ---- 摄取任务状态 / 日志 ----
   * 获取单个摄取任务状态（原始上游 JSON 透传）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.GetRAGIngestJob
   */
  getRAGIngestJob: {
    methodKind: "unary";
    input: typeof GetRAGIngestJobRequestSchema;
    output: typeof GetRAGIngestJobResponseSchema;
  },
  /**
   * 获取单个摄取任务日志（原始上游 JSON / 文本透传）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.GetRAGIngestJobLogs
   */
  getRAGIngestJobLogs: {
    methodKind: "unary";
    input: typeof GetRAGIngestJobLogsRequestSchema;
    output: typeof GetRAGIngestJobLogsResponseSchema;
  },
  /**
   * ---- 向量检索 ----
   * 在指定 collection 上做向量检索（原始上游 JSON 透传）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.SearchRAGVector
   */
  searchRAGVector: {
    methodKind: "unary";
    input: typeof SearchRAGVectorRequestSchema;
    output: typeof SearchRAGVectorResponseSchema;
  },
  /**
   * ---- 自动重跑（RAG_CRAWLER cron）任务 ----
   * 列出当前租户的自动重跑任务
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.ListRAGRerunJobs
   */
  listRAGRerunJobs: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListRAGRerunJobsResponseSchema;
  },
  /**
   * 删除（停止）一个自动重跑任务
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.DeleteRAGRerunJob
   */
  deleteRAGRerunJob: {
    methodKind: "unary";
    input: typeof DeleteRAGRerunJobRequestSchema;
    output: typeof DeleteRAGRerunJobResponseSchema;
  },
  /**
   * ---- 健康检查 ----
   * 上游 RAG 服务健康状态（原始上游 JSON 透传）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.RAGHTTPV2Service.RAGHealth
   */
  rAGHealth: {
    methodKind: "unary";
    input: typeof RAGHealthRequestSchema;
    output: typeof RAGHealthResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_rag, 0);

